(() => {
  let checkoutInProgress = false;

  function normalizePrice(value) {
    if (!value) return 0;
    return Number(String(value).replace(/[^0-9.]/g, ''));
  }

  document.addEventListener("click", async function (e) {
    const checkoutBtn = e.target.closest(
      'form[action="/checkout"] button, a[href="/checkout"], button[name="checkout"]'
    );
    if (!checkoutBtn) return;

    if (checkoutInProgress) return;
    checkoutInProgress = true;
    e.preventDefault();

    //alert("Checkout clicked. Starting insurance recalculation.");

    try {
      /* 1. Fetch cart */
      const cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
      //alert("Cart fetched. Items count: " + cart.items.length);

      /* 2. Remove existing insurance */
      const insuranceItems = cart.items.filter(i => i.vendor === 'shipping-protection');
      if (insuranceItems.length) {
        const updates = {};
        insuranceItems.forEach(i => updates[i.key] = 0);
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        //alert("Existing insurance removed.");
      }

      /* 3. Process widgets */
      const widgets = document.querySelectorAll('.ring-protection-widget');

      for (const widget of widgets) {
        const selected = widget.querySelector('input[type="radio"]:checked');
        if (!selected) continue;

        const insuranceType = selected.value;
        const lineKey = widget.dataset.lineItemKey;
        const productTitle = widget.dataset.productTitle;

        const cartItem = cart.items.find(i => i.key === lineKey);
        if (!cartItem) {
          //alert("Cart item not found for " + productTitle);
          continue;
        }

        const linePrice = cartItem.line_price / 100;
        //alert(productTitle + " line price (qty aware): $" + linePrice);

        let rules =
          insuranceType === "3 Years"
            ? window.INSURANCE_3YR_RULES
            : window.INSURANCE_LIFETIME_RULES;

        let matchedRule = null;

        for (const r of rules) {
          const start = normalizePrice(r.price_start);
          const end = normalizePrice(r.price_end);

          const conditionResult = linePrice >= start && linePrice <= end;

          // alert(
          //   "Rule check for " + productTitle +
          //   "\nRange: " + start + " - " + end +
          //   "\nLine price: " + linePrice +
          //   "\nCondition result: " + conditionResult
          // );

          if (conditionResult) {
            matchedRule = r;
            break;
          }
        }

        if (!matchedRule) {
          // alert(
          //   "No rule matched for " + productTitle +
          //   "\nFinal line price: $" + linePrice
          // );
          continue;
        }

        // alert(
        //   "Matched rule for " + productTitle +
        //   "\nInsurance total price: $" + matchedRule.total_price
        // );

        /* 4. Fetch insurance product */
        const productHandle =
          insuranceType === "3 Years"
            ? widget.dataset['3yrProductHandle']
            : widget.dataset['lifetimeProductHandle'];

        const productRes = await fetch('/products/' + productHandle + '.js');
        if (!productRes.ok) {
          //alert("Failed to fetch insurance product: " + productHandle);
          continue;
        }

        const product = await productRes.json();
        const targetPriceCents = Math.round(normalizePrice(matchedRule.total_price) * 100);

        const variant = product.variants.find(v => v.price === targetPriceCents);
        if (!variant) {
          // alert(
          //   "Variant not found for price $" + matchedRule.total_price +
          //   "\nLooking for cents: " + targetPriceCents
          // );
          continue;
        }

        //alert("Using insurance variant ID: " + variant.id);

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variant.id,
            quantity: 1,
            properties: {
              "Protection For": productTitle,
              "Coverage Type": insuranceType,
              "Covered Amount": linePrice.toFixed(2),
              "_Linked Line Key": lineKey
            }
          })
        });

        //alert("Insurance added for " + productTitle);
      }

      //alert("All insurance processed. Redirecting to checkout.");
      setTimeout(function() {
        window.location.href = '/checkout';
      }, 1000);

    } catch (err) {
      console.log("Checkout Error: " + err.message);
    }
  });
})();


//For change Price on qty change
(() => {

  function normalizePrice(value) {
    if (!value) return 0;
    return Number(String(value).replace(/[^0-9.]/g, ''));
  }

  async function updateInsuranceWidgetPrices() {
    // alert("UI Sync: Insurance price recalculation started");

    const widgets = document.querySelectorAll('.ring-protection-widget');
    if (!widgets.length) {
      // alert("UI Sync: No widgets found");
      return;
    }

    let cart;
    try {
      cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
    } catch (e) {
      // alert("UI Sync: Failed to fetch cart");
      return;
    }

    // alert("UI Sync: Cart fetched, items: " + cart.items.length);

    widgets.forEach(widget => {
      const lineKey = widget.dataset.lineItemKey;
      const productTitle = widget.dataset.productTitle;

      if (!lineKey) {
        // alert("UI Sync: Missing line item key");
        return;
      }

      const cartItem = cart.items.find(i => i.key === lineKey);
      if (!cartItem) {
        // alert("UI Sync: Cart item not found for " + productTitle);
        return;
      }

      const linePrice = cartItem.line_price / 100;

      // alert(
      //   "UI Sync: Processing " + productTitle +
      //   "\nQty-aware price: $" + linePrice
      // );

      const ruleGroups = [
        { plan: '3yr', rules: window.INSURANCE_3YR_RULES },
        { plan: 'lifetime', rules: window.INSURANCE_LIFETIME_RULES }
      ];

      ruleGroups.forEach(group => {
        if (!group.rules || !group.rules.length) {
          // alert("UI Sync: Rules missing for plan " + group.plan);
          return;
        }

        let matchedRule = null;

        for (const rule of group.rules) {
          const start = normalizePrice(rule.price_start);
          const end = normalizePrice(rule.price_end);
          const condition = linePrice >= start && linePrice <= end;

          // alert(
          //   "UI Sync rule check" +
          //   "\nProduct: " + productTitle +
          //   "\nPlan: " + group.plan +
          //   "\nRange: " + start + " - " + end +
          //   "\nLine price: " + linePrice +
          //   "\nMatch: " + condition
          // );

          if (condition) {
            matchedRule = rule;
            break;
          }
        }

        if (!matchedRule) {
          // alert("UI Sync: No rule matched for " + productTitle + " (" + group.plan + ")");
          return;
        }

        const priceEl = widget.querySelector(
          '.insurance-price[data-plan="' + group.plan + '"]'
        );

        if (!priceEl) {
          // alert("UI Sync: Price element missing for plan " + group.plan);
          return;
        }

        priceEl.textContent = '$' + matchedRule.total_price;

        // alert(
        //   "UI Sync: Price updated" +
        //   "\nProduct: " + productTitle +
        //   "\nPlan: " + group.plan +
        //   "\nNew price: $" + matchedRule.total_price
        // );
      });
    });

    // alert("UI Sync: Insurance price recalculation complete");
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateInsuranceWidgetPrices);
  } else {
    updateInsuranceWidgetPrices();
  }

})();